/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { SegmentedOption } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function AnalyticsView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '20px 12px 40px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {' '}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
        {' '}
        <div style={{ flex: '1', minWidth: '220px' }}>
          {' '}
          <div style={{ fontSize: '15px', fontWeight: '500', letterSpacing: '-0.01em' }}>Analytics</div>{' '}
          <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '3px' }}>
            Comprehensive performance metrics and trade analysis
          </div>{' '}
        </div>{' '}
        <div
          style={{
            display: 'flex',
            gap: '2px',
            padding: '3px',
            borderRadius: '99px',
            border: '1px solid var(--l8)',
            flex: 'none',
          }}
        >
          {' '}
          {(m.anRanges ?? []).map((r, i61) => (
            <Fragment key={i61}>
              {' '}
              <SegmentedOption
                bg={r?.bg}
                fg={r?.fg}
                fw={r?.fw}
                variant="b"
                onClick={r?.go}
                aria-label={dc.s(r?.label)}
              >
                {dc.t(r?.label)}
              </SegmentedOption>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,178px),1fr))',
          gap: '12px',
        }}
      >
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '13px 15px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Net P&L
            <span
              style={{
                fontSize: '9px',
                padding: '1px 6px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted2)',
              }}
            >
              {dc.t(m.anCount)}
            </span>
          </div>
          <div
            style={dc.css(
              `font-size:17px;font-weight:600;letter-spacing:-0.02em;font-variant-numeric:tabular-nums;color:${dc.s(m.anNetFg)};margin-top:5px`,
            )}
          >
            {dc.t(m.anNet)}
          </div>
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '13px 15px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <div style={{ flex: '1', minWidth: '0' }}>
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Trade Win %
            </div>
            <div
              style={{
                fontSize: '17px',
                fontWeight: '600',
                letterSpacing: '-0.02em',
                fontVariantNumeric: 'tabular-nums',
                marginTop: '5px',
              }}
            >
              {dc.t(m.anWinPct)}
            </div>
          </div>
          <div style={{ position: 'relative', width: '74px', flex: 'none' }}>
            {' '}
            <svg viewBox="0 0 200 114" style={{ width: '74px', display: 'block' }}>
              {(m.anWinTicks ?? []).map((k, i62) => (
                <Fragment key={i62}>
                  <line
                    x1={dc.a(k?.x1)}
                    y1={dc.a(k?.y1)}
                    x2={dc.a(k?.x2)}
                    y2={dc.a(k?.y2)}
                    stroke={dc.a(k?.col)}
                    strokeWidth={dc.a(k?.w)}
                    strokeLinecap="round"
                    opacity={dc.a(k?.op)}
                  ></line>
                </Fragment>
              ))}
            </svg>{' '}
            <div
              style={{
                position: 'absolute',
                left: '0',
                right: '0',
                bottom: '2px',
                textAlign: 'center',
                fontSize: '9px',
                color: 'var(--muted2)',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {dc.t(m.anWinSub)}
            </div>{' '}
          </div>
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '13px 15px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <div style={{ flex: '1', minWidth: '0' }}>
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Profit Factor
            </div>
            <div
              style={dc.css(
                `font-size:17px;font-weight:600;letter-spacing:-0.02em;font-variant-numeric:tabular-nums;color:${dc.s(m.anPfFg)};margin-top:5px`,
              )}
            >
              {dc.t(m.anPf)}
            </div>
          </div>
          <div style={{ position: 'relative', width: '74px', flex: 'none' }}>
            <svg viewBox="0 0 200 114" style={{ width: '74px', display: 'block' }}>
              {(m.anPfTicks ?? []).map((k, i63) => (
                <Fragment key={i63}>
                  <line
                    x1={dc.a(k?.x1)}
                    y1={dc.a(k?.y1)}
                    x2={dc.a(k?.x2)}
                    y2={dc.a(k?.y2)}
                    stroke={dc.a(k?.col)}
                    strokeWidth={dc.a(k?.w)}
                    strokeLinecap="round"
                    opacity={dc.a(k?.op)}
                  ></line>
                </Fragment>
              ))}
            </svg>
          </div>
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '13px 15px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <div style={{ flex: '1', minWidth: '0' }}>
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Day Win %
            </div>
            <div
              style={{
                fontSize: '17px',
                fontWeight: '600',
                letterSpacing: '-0.02em',
                fontVariantNumeric: 'tabular-nums',
                marginTop: '5px',
              }}
            >
              {dc.t(m.anDayPct)}
            </div>
          </div>
          <div style={{ position: 'relative', width: '74px', flex: 'none' }}>
            {' '}
            <svg viewBox="0 0 200 114" style={{ width: '74px', display: 'block' }}>
              {(m.anDayTicks ?? []).map((k, i64) => (
                <Fragment key={i64}>
                  <line
                    x1={dc.a(k?.x1)}
                    y1={dc.a(k?.y1)}
                    x2={dc.a(k?.x2)}
                    y2={dc.a(k?.y2)}
                    stroke={dc.a(k?.col)}
                    strokeWidth={dc.a(k?.w)}
                    strokeLinecap="round"
                    opacity={dc.a(k?.op)}
                  ></line>
                </Fragment>
              ))}
            </svg>{' '}
            <div
              style={{
                position: 'absolute',
                left: '0',
                right: '0',
                bottom: '2px',
                textAlign: 'center',
                fontSize: '9px',
                color: 'var(--muted2)',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {dc.t(m.anDaySub)}
            </div>{' '}
          </div>
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '13px 15px',
          }}
        >
          {' '}
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Avg Win/Loss
          </div>
          <div
            style={{
              fontSize: '17px',
              fontWeight: '600',
              letterSpacing: '-0.02em',
              fontVariantNumeric: 'tabular-nums',
              marginTop: '5px',
            }}
          >
            {dc.t(m.anRatio)}
          </div>{' '}
          <div
            style={{
              display: 'flex',
              gap: '2px',
              height: '7px',
              borderRadius: '99px',
              overflow: 'hidden',
              marginTop: '8px',
            }}
          >
            <div style={dc.css(`width:${dc.s(m.anRatioW)};background:var(--pos)`)}></div>
            <div style={{ flex: '1', background: 'var(--neg)' }}></div>
          </div>{' '}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
            <span style={{ fontSize: '9px', color: 'var(--pos)', fontVariantNumeric: 'tabular-nums' }}>
              {dc.t(m.anAvgWin)}
            </span>
            <span style={{ fontSize: '9px', color: 'var(--neg)', fontVariantNumeric: 'tabular-nums' }}>
              {dc.t(m.anAvgLoss)}
            </span>
          </div>{' '}
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '13px 15px',
          }}
        >
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Best Win Streak
          </div>
          <div
            style={{
              fontSize: '17px',
              fontWeight: '600',
              letterSpacing: '-0.02em',
              fontVariantNumeric: 'tabular-nums',
              marginTop: '5px',
            }}
          >
            {dc.t(m.anStreak)}
          </div>
          <div
            style={{
              fontSize: '10px',
              color: 'var(--muted2)',
              marginTop: '2px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {dc.t(m.anStreakSub)}
          </div>
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'flex',
          gap: '2px',
          padding: '3px',
          borderRadius: '99px',
          border: '1px solid var(--l8)',
          flexWrap: 'wrap',
          alignSelf: 'flex-start',
        }}
      >
        {' '}
        {(m.anTabs ?? []).map((t, i65) => (
          <Fragment key={i65}>
            {' '}
            <button
              onClick={t?.go}
              aria-label={dc.a(t?.label)}
              style={dc.css(
                `padding:5px 13px;border-radius:99px;border:none;background:${dc.s(t?.bg)};color:${dc.s(t?.fg)};font-weight:${dc.s(t?.fw)};font-size:10.5px;cursor:pointer;white-space:nowrap`,
              )}
            >
              {dc.t(t?.label)}
            </button>{' '}
          </Fragment>
        ))}{' '}
      </div>{' '}
      {m.anEmpty ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '40px 20px',
              textAlign: 'center',
            }}
          >
            <i className="ph ph-chart-line" style={{ fontSize: '26px', color: 'var(--ghost)' }}></i>
            <div style={{ fontSize: '12.5px', color: 'var(--text-mid)', marginTop: '9px' }}>
              No trades in this range
            </div>
            <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '3px' }}>
              Widen the timeframe or clear a filter.
            </div>
          </div>{' '}
        </>
      ) : null}{' '}
      {m.anIsOverview ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            {' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,260px),1fr))',
                gap: '12px',
              }}
            >
              {' '}
              {(m.anCmp ?? []).map((cp, i66) => (
                <Fragment key={i66}>
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '14px 16px',
                    }}
                  >
                    {' '}
                    <div
                      style={{
                        fontSize: '9.5px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      {dc.t(cp?.label)}
                    </div>{' '}
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginTop: '6px' }}>
                      {' '}
                      <span
                        style={dc.css(
                          `font-size:19px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(cp?.curFg)};font-variant-numeric:tabular-nums`,
                        )}
                      >
                        {dc.t(cp?.cur)}
                      </span>{' '}
                      <span
                        style={{
                          fontSize: '10.5px',
                          color: 'var(--muted2)',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {'vs '}
                        {dc.t(cp?.prev)}
                      </span>{' '}
                    </div>{' '}
                    <div
                      style={dc.css(
                        `font-size:10.5px;color:${dc.s(cp?.deltaFg)};margin-top:4px;font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(cp?.deltaLabel)}
                    </div>{' '}
                    <div
                      style={{
                        fontSize: '10px',
                        color: 'var(--muted2)',
                        marginTop: '6px',
                        paddingTop: '8px',
                        borderTop: '1px solid var(--l6)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(cp?.curN)}
                      {' trades · '}
                      {dc.t(cp?.curWr)}
                      {' win rate'}
                    </div>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,360px),1fr))',
                gap: '14px',
              }}
            >
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {' '}
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap' }}>
                  {' '}
                  <span style={{ fontSize: '12.5px', fontWeight: '500' }}>
                    Daily Net Cumulative P&L & Account Balance
                  </span>{' '}
                  <div style={{ flex: '1' }}></div>{' '}
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '5px',
                      fontSize: '10px',
                      color: 'var(--muted2)',
                    }}
                  >
                    <span
                      style={dc.css(`width:10px;height:2px;border-radius:99px;background:${dc.s(m.anCumFg)}`)}
                    ></span>
                    Cumulative P&L
                  </span>{' '}
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '5px',
                      fontSize: '10px',
                      color: 'var(--muted2)',
                    }}
                  >
                    <span
                      style={{ width: '10px', height: '2px', borderRadius: '99px', background: 'var(--sky)' }}
                    ></span>
                    Account balance
                  </span>{' '}
                </div>{' '}
                {m.anHasCum ? (
                  <>
                    {' '}
                    <svg
                      viewBox="0 0 420 150"
                      preserveAspectRatio="none"
                      style={{ width: '100%', height: '200px', marginTop: '10px' }}
                    >
                      {' '}
                      <line
                        x1="0"
                        y1={dc.a(m.anCumZero)}
                        x2="420"
                        y2={dc.a(m.anCumZero)}
                        stroke="var(--l8)"
                      ></line>{' '}
                      <defs>
                        <linearGradient id="ancum" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0" stopColor="var(--pos)" stopOpacity="0.2"></stop>
                          <stop offset="1" stopColor="var(--pos)" stopOpacity="0"></stop>
                        </linearGradient>
                      </defs>{' '}
                      <path d={dc.a(m.anCumFill)} fill="url(#ancum)"></path>{' '}
                      <path
                        d={dc.a(m.anBalPath)}
                        fill="none"
                        stroke="var(--sky)"
                        strokeWidth="1.4"
                        strokeDasharray="4 3"
                        vectorEffect="non-scaling-stroke"
                      ></path>{' '}
                      <path
                        d={dc.a(m.anCumPath)}
                        fill="none"
                        stroke={dc.a(m.anCumFg)}
                        strokeWidth="1.8"
                        vectorEffect="non-scaling-stroke"
                      ></path>{' '}
                    </svg>{' '}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '14px',
                        marginTop: '8px',
                        paddingTop: '9px',
                        borderTop: '1px solid var(--l6)',
                      }}
                    >
                      {' '}
                      <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>
                        {'Balance '}
                        <span style={{ color: 'var(--text2)', fontVariantNumeric: 'tabular-nums' }}>
                          {dc.t(m.anBalStart)}
                          {' → '}
                          {dc.t(m.anBalEnd)}
                        </span>
                      </span>{' '}
                    </div>{' '}
                  </>
                ) : null}{' '}
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {' '}
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                  <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Drawdown from peak</span>
                  <div style={{ flex: '1' }}></div>
                  <span style={{ fontSize: '11px', color: 'var(--neg)', fontVariantNumeric: 'tabular-nums' }}>
                    {'worst '}
                    {dc.t(m.anDdWorst)}
                  </span>
                </div>{' '}
                <svg
                  viewBox="0 0 420 92"
                  preserveAspectRatio="none"
                  style={{ width: '100%', height: '120px', marginTop: '10px' }}
                >
                  {' '}
                  <path
                    d={dc.a(m.anDdPath)}
                    fill="none"
                    stroke="var(--neg)"
                    strokeWidth="1.6"
                    vectorEffect="non-scaling-stroke"
                  ></path>{' '}
                </svg>{' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                    marginTop: '4px',
                  }}
                >
                  Deeper is worse · measured against the running equity peak
                </div>{' '}
                {m.anDdHasEpisodes ? (
                  <>
                    {' '}
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0',
                        marginTop: '12px',
                        paddingTop: '10px',
                        borderTop: '1px solid var(--l6)',
                      }}
                    >
                      {' '}
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                          marginBottom: '6px',
                        }}
                      >
                        Drawdown schedule
                      </div>{' '}
                      {(m.anDdEpisodes ?? []).map((dd, i67) => (
                        <Fragment key={i67}>
                          {' '}
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              padding: '6px 0',
                              borderTop: '1px solid var(--l5)',
                            }}
                          >
                            {' '}
                            <span
                              style={{ fontSize: '10.5px', color: 'var(--text2)', flex: '1', minWidth: '0' }}
                            >
                              {dc.t(dd?.range)}
                            </span>{' '}
                            <span
                              style={{
                                fontSize: '10.5px',
                                fontWeight: '600',
                                color: 'var(--neg)',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(dd?.depth)}
                            </span>{' '}
                            <span
                              style={dc.css(`font-size:9.5px;color:${dc.s(dd?.statusFg)};white-space:nowrap`)}
                            >
                              {dc.t(dd?.status)}
                            </span>{' '}
                          </div>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </>
                ) : null}{' '}
                {m.anDdNoEpisodes ? (
                  <>
                    {' '}
                    <div
                      style={{
                        fontSize: '10.5px',
                        color: 'var(--faint)',
                        marginTop: '12px',
                        paddingTop: '10px',
                        borderTop: '1px solid var(--l6)',
                      }}
                    >
                      No drawdown episodes in this period
                    </div>{' '}
                  </>
                ) : null}{' '}
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Net P&L by day</div>{' '}
                <div style={{ height: '150px', display: 'flex', flexDirection: 'column', marginTop: '12px' }}>
                  {' '}
                  <div style={{ height: '50%', display: 'flex', alignItems: 'flex-end', gap: '5px' }}>
                    {(m.anDayBars ?? []).map((b, i68) => (
                      <Fragment key={i68}>
                        <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                          {b?.pos ? (
                            <div
                              style={dc.css(
                                `width:100%;max-width:22px;margin:0 auto;height:${dc.s(b?.h)};border-radius:3px 3px 0 0;background:var(--pos)`,
                              )}
                            ></div>
                          ) : null}
                        </div>
                      </Fragment>
                    ))}
                  </div>{' '}
                  <div style={{ height: '1px', background: 'var(--l10)' }}></div>{' '}
                  <div style={{ height: '50%', display: 'flex', alignItems: 'flex-start', gap: '5px' }}>
                    {(m.anDayBars ?? []).map((b, i69) => (
                      <Fragment key={i69}>
                        <div style={{ flex: '1', height: '100%' }}>
                          {b?.neg ? (
                            <div
                              style={dc.css(
                                `width:100%;max-width:22px;margin:0 auto;height:${dc.s(b?.h)};border-radius:0 0 3px 3px;background:var(--neg);opacity:0.85`,
                              )}
                            ></div>
                          ) : null}
                        </div>
                      </Fragment>
                    ))}
                  </div>{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.anIsPerf ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
            }}
          >
            {' '}
            <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Performance metrics</div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,220px),1fr))',
                gap: '0 20px',
                marginTop: '10px',
              }}
            >
              {' '}
              {(m.anPerfStats ?? []).map((s, i70) => (
                <Fragment key={i70}>
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: '12px',
                      padding: '8px 0',
                      borderBottom: '1px solid var(--l5)',
                      fontSize: '11.5px',
                    }}
                  >
                    <span style={{ color: 'var(--muted2)' }}>{dc.t(s?.k)}</span>
                    <span style={{ color: 'var(--text2)', fontVariantNumeric: 'tabular-nums' }}>
                      {dc.t(s?.v)}
                    </span>
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.anIsCal ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
              <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Calendar</span>
              <div
                style={{
                  flex: '1',
                  height: '1px',
                  background: 'linear-gradient(90deg,var(--l10),transparent)',
                }}
              ></div>
              <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>Last 4 weeks · net per day</span>
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(7,minmax(0,1fr))',
                gap: '6px',
                marginTop: '12px',
              }}
            >
              {' '}
              {(m.anCal ?? []).map((c, i71) => (
                <Fragment key={i71}>
                  {' '}
                  <div
                    style={dc.css(
                      `border-radius:9px;background:${dc.s(c?.bg)};padding:8px 6px;min-height:52px;display:flex;flex-direction:column;justify-content:space-between`,
                    )}
                  >
                    <span
                      style={dc.css(
                        `font-size:10px;font-weight:500;color:${dc.s(c?.dayFg)};font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(c?.day)}
                    </span>
                    <span
                      style={dc.css(
                        `font-size:10px;font-weight:600;color:${dc.s(c?.fg)};font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(c?.val)}
                    </span>
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            <div style={{ marginTop: '16px', paddingTop: '13px', borderTop: '1px solid var(--l6)' }}>
              {' '}
              <div
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                Weekday totals
              </div>{' '}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '9px', marginTop: '10px' }}>
                {' '}
                {(m.anWeekTotals ?? []).map((d, i72) => (
                  <Fragment key={i72}>
                    {' '}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '11px', color: 'var(--text2)', width: '34px', flex: 'none' }}>
                        {dc.t(d?.d)}
                      </span>
                      <div
                        style={{
                          flex: '1',
                          height: '5px',
                          borderRadius: '99px',
                          background: 'var(--l6)',
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={dc.css(
                            `width:${dc.s(d?.w)};height:100%;border-radius:99px;background:${dc.s(d?.bar)}`,
                          )}
                        ></div>
                      </div>
                      <span
                        style={dc.css(
                          `font-size:11px;font-weight:600;color:${dc.s(d?.pnlFg)};font-variant-numeric:tabular-nums;width:86px;text-align:right;flex:none`,
                        )}
                      >
                        {dc.t(d?.pnl)}
                      </span>
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.anIsSessions ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
              }}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
                {' '}
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '9px', flex: '1', minWidth: '200px' }}
                >
                  <i className="ph ph-globe" style={{ fontSize: '16px', color: 'var(--muted)' }}></i>
                  <span style={{ fontSize: '13px', fontWeight: '500' }}>Market Session Performance</span>
                </div>{' '}
                {m.anBestSession ? (
                  <>
                    {' '}
                    <span
                      style={{
                        fontSize: '11px',
                        padding: '5px 12px',
                        borderRadius: '99px',
                        border: '1px solid color-mix(in srgb, var(--sky-fill) 45%, transparent)',
                        color: 'var(--sky)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {'Best: '}
                      {dc.t(m.anBestSession?.label)}
                      {' ('}
                      {dc.t(m.anBestSession?.pnl)})
                    </span>{' '}
                  </>
                ) : null}{' '}
              </div>{' '}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,220px),1fr))',
                  gap: '12px',
                  marginTop: '14px',
                }}
              >
                {' '}
                {(m.anSessionCards ?? []).map((s, i73) => (
                  <Fragment key={i73}>
                    {' '}
                    <div
                      style={{
                        border: '1px solid var(--l8)',
                        borderRadius: '12px',
                        background: 'var(--l3)',
                        padding: '14px 15px',
                      }}
                    >
                      {' '}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <i
                          className={`ph ${dc.s(s?.icon)}`}
                          style={dc.css(`font-size:13px;color:${dc.s(s?.ink)}`)}
                        ></i>
                        <span
                          style={dc.css(
                            `font-size:12px;font-weight:500;color:${dc.s(s?.ink)};flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap`,
                          )}
                        >
                          {dc.t(s?.label)}
                        </span>
                        <span
                          style={{
                            fontSize: '9.5px',
                            color: 'var(--muted2)',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(s?.share)}
                        </span>
                      </div>{' '}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '11px' }}>
                        <i
                          className="ph ph-trend-up"
                          style={dc.css(`font-size:13px;color:${dc.s(s?.pnlFg)}`)}
                        ></i>
                        <span
                          style={dc.css(
                            `font-size:19px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(s?.pnlFg)};font-variant-numeric:tabular-nums`,
                          )}
                        >
                          {dc.t(s?.pnl)}
                        </span>
                      </div>{' '}
                      <div
                        style={{
                          fontSize: '10px',
                          color: 'var(--muted2)',
                          marginTop: '3px',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {'Avg '}
                        {dc.t(s?.avg)}
                      </div>{' '}
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(3,1fr)',
                          gap: '8px',
                          marginTop: '13px',
                          paddingTop: '11px',
                          borderTop: '1px solid var(--l6)',
                        }}
                      >
                        {' '}
                        <div>
                          <div
                            style={{
                              fontSize: '9px',
                              letterSpacing: '0.1em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                            }}
                          >
                            Trades
                          </div>
                          <div
                            style={{
                              fontSize: '13px',
                              fontWeight: '600',
                              marginTop: '3px',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(s?.trades)}
                          </div>
                        </div>{' '}
                        <div>
                          <div
                            style={{
                              fontSize: '9px',
                              letterSpacing: '0.1em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                            }}
                          >
                            Win%
                          </div>
                          <div
                            style={{
                              fontSize: '13px',
                              fontWeight: '600',
                              marginTop: '3px',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(s?.wr)}
                          </div>
                        </div>{' '}
                        <div>
                          <div
                            style={{
                              fontSize: '9px',
                              letterSpacing: '0.1em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                            }}
                          >
                            W/L
                          </div>
                          <div
                            style={{
                              fontSize: '13px',
                              fontWeight: '600',
                              marginTop: '3px',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(s?.wl)}
                          </div>
                        </div>{' '}
                      </div>{' '}
                      <div
                        style={{
                          height: '4px',
                          borderRadius: '99px',
                          background: 'var(--l6)',
                          marginTop: '12px',
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={dc.css(
                            `width:${dc.s(s?.w)};height:100%;border-radius:99px;background:${dc.s(s?.dot)}`,
                          )}
                        ></div>
                      </div>{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,320px),1fr))',
                gap: '14px',
              }}
            >
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                  gridColumn: '1 / -1',
                }}
              >
                {' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <i className="ph ph-clock" style={{ fontSize: '14px', color: 'var(--muted)' }}></i>
                  <span style={{ fontSize: '12.5px', fontWeight: '500' }}>
                    Trade Distribution by Hour (UTC)
                  </span>
                </div>{' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '3px',
                    height: '70px',
                    marginTop: '16px',
                    borderTop: '1px solid var(--l7)',
                  }}
                >
                  {' '}
                  {(m.anHourStrip ?? []).map((b, i74) => (
                    <Fragment key={i74}>
                      {' '}
                      <div
                        style={{
                          flex: '1',
                          height: '70px',
                          display: 'flex',
                          alignItems: 'flex-end',
                          justifyContent: 'center',
                        }}
                      >
                        {' '}
                        {b?.has ? (
                          <>
                            {' '}
                            <div
                              style={dc.css(
                                `width:70%;max-width:34px;height:${dc.s(b?.hpx)};border-radius:6px 6px 0 0;background:${dc.s(b?.dot)};display:flex;align-items:flex-start;justify-content:center;padding-top:3px`,
                              )}
                            >
                              <span style={dc.css(`font-size:9px;color:${dc.s(b?.ink)}`)}>{dc.t(b?.n)}</span>
                            </div>{' '}
                          </>
                        ) : null}{' '}
                        {b?.has ? (
                          <>
                            {' '}
                            <div style={{ width: '100%', height: '1px', background: 'var(--l8)' }}></div>{' '}
                          </>
                        ) : null}{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
                <div style={{ display: 'flex', gap: '3px', marginTop: '6px' }}>
                  {' '}
                  {(m.anHourStrip ?? []).map((b, i75) => (
                    <Fragment key={i75}>
                      <span
                        style={{
                          flex: '1',
                          textAlign: 'center',
                          fontSize: '9px',
                          color: 'var(--faint)',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(b?.showLabel)}
                      </span>
                    </Fragment>
                  ))}{' '}
                </div>{' '}
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '14px',
                    marginTop: '14px',
                    paddingTop: '11px',
                    borderTop: '1px solid var(--l6)',
                  }}
                >
                  {' '}
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '10.5px',
                      color: 'var(--muted2)',
                    }}
                  >
                    <span
                      style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: 'var(--vio-fill)',
                      }}
                    ></span>
                    Asia
                  </span>{' '}
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '10.5px',
                      color: 'var(--muted2)',
                    }}
                  >
                    <span
                      style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: 'var(--sky-fill)',
                      }}
                    ></span>
                    London
                  </span>{' '}
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '10.5px',
                      color: 'var(--muted2)',
                    }}
                  >
                    <span
                      style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--amb)' }}
                    ></span>
                    London → NY overlap
                  </span>{' '}
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '10.5px',
                      color: 'var(--muted2)',
                    }}
                  >
                    <span
                      style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--pos)' }}
                    ></span>
                    New York
                  </span>{' '}
                </div>{' '}
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                  gridColumn: '1 / -1',
                }}
              >
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>By symbol</div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '11px', marginTop: '12px' }}>
                  {' '}
                  {(m.anSymbols ?? []).map((g, i76) => (
                    <Fragment key={i76}>
                      {' '}
                      <div>
                        {' '}
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                          <span
                            style={{
                              fontSize: '11.5px',
                              color: 'var(--text2)',
                              flex: '1',
                              minWidth: '0',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {dc.t(g?.label)}
                          </span>
                          <span
                            style={{
                              fontSize: '10px',
                              color: 'var(--muted2)',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(g?.count)}
                            {' · '}
                            {dc.t(g?.wr)}
                          </span>
                          <span
                            style={dc.css(
                              `font-size:11.5px;font-weight:600;color:${dc.s(g?.pnlFg)};font-variant-numeric:tabular-nums`,
                            )}
                          >
                            {dc.t(g?.pnl)}
                          </span>
                        </div>{' '}
                        <div
                          style={{
                            height: '4px',
                            borderRadius: '99px',
                            background: 'var(--l6)',
                            marginTop: '6px',
                            overflow: 'hidden',
                          }}
                        >
                          <div
                            style={dc.css(
                              `width:${dc.s(g?.w)};height:100%;border-radius:99px;background:${dc.s(g?.bar)}`,
                            )}
                          ></div>
                        </div>{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>
              </div>{' '}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              marginTop: '14px',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
              {' '}
              <div style={{ flex: '1', minWidth: '200px' }}>
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Session performance heatmap</div>
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  Net P&L by session and weekday
                </div>
              </div>{' '}
              <div
                style={{
                  display: 'flex',
                  gap: '2px',
                  padding: '3px',
                  borderRadius: '99px',
                  border: '1px solid var(--l8)',
                  flex: 'none',
                }}
              >
                {' '}
                {(m.anHeatRanges ?? []).map((p, i77) => (
                  <Fragment key={i77}>
                    {' '}
                    <SegmentedOption
                      bg={p?.bg}
                      fg={p?.fg}
                      fw={p?.fw}
                      variant="c"
                      onClick={p?.go}
                      aria-label={dc.s(p?.label)}
                    >
                      {dc.t(p?.label)}
                    </SegmentedOption>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
            {m.anHeatEmpty ? (
              <>
                {' '}
                <div
                  style={{ padding: '30px 0', textAlign: 'center', fontSize: '11px', color: 'var(--faint)' }}
                >
                  No trades in this range
                </div>{' '}
              </>
            ) : null}{' '}
            {m.anHeatHasData ? (
              <>
                {' '}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '110px repeat(5,1fr)',
                    gap: '6px',
                    marginTop: '14px',
                  }}
                >
                  {' '}
                  <span></span>{' '}
                  {(m.anHeatDays ?? []).map((d, i78) => (
                    <Fragment key={i78}>
                      <span
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.09em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                          textAlign: 'center',
                        }}
                      >
                        {dc.t(d)}
                      </span>
                    </Fragment>
                  ))}{' '}
                </div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px' }}>
                  {' '}
                  {(m.anHeatRows ?? []).map((row, i79) => (
                    <Fragment key={i79}>
                      {' '}
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '110px repeat(5,1fr)',
                          gap: '6px',
                          alignItems: 'stretch',
                        }}
                      >
                        {' '}
                        <span
                          style={{
                            fontSize: '10.5px',
                            color: 'var(--text2)',
                            display: 'flex',
                            alignItems: 'center',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {dc.t(row?.label)}
                        </span>{' '}
                        {(row?.cells ?? []).map((c, i80) => (
                          <Fragment key={i80}>
                            {' '}
                            {c?.has ? (
                              <>
                                {' '}
                                <div
                                  style={dc.css(
                                    `border-radius:8px;background:${dc.s(c?.bg)};padding:8px 6px;min-height:50px;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:2px`,
                                  )}
                                >
                                  <span
                                    style={dc.css(
                                      `font-size:11px;font-weight:600;color:${dc.s(c?.fg)};font-variant-numeric:tabular-nums`,
                                    )}
                                  >
                                    {dc.t(c?.pnl)}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: '9px',
                                      color: 'var(--muted2)',
                                      fontVariantNumeric: 'tabular-nums',
                                    }}
                                  >
                                    {dc.t(c?.n)}
                                    {' · '}
                                    {dc.t(c?.wr)}
                                  </span>
                                </div>{' '}
                              </>
                            ) : null}{' '}
                            {c?.has ? (
                              <>
                                {' '}
                                <div
                                  style={{
                                    borderRadius: '8px',
                                    background: 'var(--l4)',
                                    minHeight: '50px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <span style={{ fontSize: '9.5px', color: 'var(--faint)' }}>—</span>
                                </div>{' '}
                              </>
                            ) : null}{' '}
                          </Fragment>
                        ))}{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </>
            ) : null}{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.anIsDayTime ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            {' '}
            <div
              style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', alignItems: 'start' }}
            >
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>P&L by entry hour</div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  London time, from each trade's own entry stamp
                </div>{' '}
                <div style={{ height: '150px', display: 'flex', flexDirection: 'column', marginTop: '14px' }}>
                  {' '}
                  <div style={{ height: '50%', display: 'flex', alignItems: 'flex-end', gap: '6px' }}>
                    {(m.anHours ?? []).map((b, i81) => (
                      <Fragment key={i81}>
                        <div style={{ flex: '1', height: '100%', display: 'flex', alignItems: 'flex-end' }}>
                          {b?.pos ? (
                            <div
                              style={dc.css(
                                `width:100%;max-width:26px;margin:0 auto;height:${dc.s(b?.height)};border-radius:3px 3px 0 0;background:var(--pos)`,
                              )}
                            ></div>
                          ) : null}
                        </div>
                      </Fragment>
                    ))}
                  </div>{' '}
                  <div style={{ height: '1px', background: 'var(--l10)' }}></div>{' '}
                  <div style={{ height: '50%', display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                    {(m.anHours ?? []).map((b, i82) => (
                      <Fragment key={i82}>
                        <div style={{ flex: '1', height: '100%' }}>
                          {b?.neg ? (
                            <div
                              style={dc.css(
                                `width:100%;max-width:26px;margin:0 auto;height:${dc.s(b?.height)};border-radius:0 0 3px 3px;background:var(--neg);opacity:0.85`,
                              )}
                            ></div>
                          ) : null}
                        </div>
                      </Fragment>
                    ))}
                  </div>{' '}
                </div>{' '}
                <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
                  {(m.anHours ?? []).map((b, i83) => (
                    <Fragment key={i83}>
                      <span
                        style={{
                          flex: '1',
                          textAlign: 'center',
                          fontSize: '9px',
                          color: 'var(--faint)',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(b?.h)}
                      </span>
                    </Fragment>
                  ))}
                </div>{' '}
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Win % by Day of Week</div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  Green ≥ 50% win rate, red below
                </div>{' '}
                <div
                  style={{
                    height: '150px',
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '8px',
                    marginTop: '14px',
                  }}
                >
                  {' '}
                  {(m.anWinByDow ?? []).map((w, i84) => (
                    <Fragment key={i84}>
                      {' '}
                      <div
                        style={{
                          flex: '1',
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                          gap: '6px',
                        }}
                      >
                        {' '}
                        <span
                          style={{
                            fontSize: '9.5px',
                            color: 'var(--muted2)',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(w?.wr)}
                        </span>{' '}
                        <div
                          style={dc.css(
                            `width:100%;max-width:30px;height:${dc.s(w?.h)};border-radius:4px 4px 0 0;background:${dc.s(w?.bar)}`,
                          )}
                        ></div>{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
                <div style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>
                  {(m.anWinByDow ?? []).map((w, i85) => (
                    <Fragment key={i85}>
                      <span
                        style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}
                      >
                        {dc.t(w?.d)}
                      </span>
                    </Fragment>
                  ))}
                </div>{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
              }}
            >
              <div style={{ fontSize: '12.5px', fontWeight: '500' }}>By weekday</div>{' '}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '11px', marginTop: '12px' }}>
                {' '}
                {(m.anWeekdays ?? []).map((g, i86) => (
                  <Fragment key={i86}>
                    {' '}
                    <div>
                      {' '}
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span
                          style={{
                            fontSize: '11.5px',
                            color: 'var(--text2)',
                            flex: '1',
                            minWidth: '0',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {dc.t(g?.label)}
                        </span>
                        <span
                          style={{
                            fontSize: '10px',
                            color: 'var(--muted2)',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(g?.count)}
                          {' · '}
                          {dc.t(g?.wr)}
                        </span>
                        <span
                          style={dc.css(
                            `font-size:11.5px;font-weight:600;color:${dc.s(g?.pnlFg)};font-variant-numeric:tabular-nums`,
                          )}
                        >
                          {dc.t(g?.pnl)}
                        </span>
                      </div>{' '}
                      <div
                        style={{
                          height: '4px',
                          borderRadius: '99px',
                          background: 'var(--l6)',
                          marginTop: '6px',
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={dc.css(
                            `width:${dc.s(g?.w)};height:100%;border-radius:99px;background:${dc.s(g?.bar)}`,
                          )}
                        ></div>
                      </div>{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>
            </div>{' '}
            <div
              style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', alignItems: 'start' }}
            >
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>
                  Trade Entry & Day/Time Scatter
                </div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  Each dot is one trade · size scales with P&L magnitude
                </div>{' '}
                <div style={{ display: 'flex', marginTop: '14px' }}>
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      width: '28px',
                      flex: 'none',
                      paddingBottom: '14px',
                    }}
                  >
                    {' '}
                    {(m.anEntryDayRows ?? []).map((r, i87) => (
                      <Fragment key={i87}>
                        <span style={{ fontSize: '9px', color: 'var(--muted2)', lineHeight: '1' }}>
                          {dc.t(r?.d)}
                        </span>
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                  <div style={{ flex: '1', minWidth: '0' }}>
                    {' '}
                    <svg
                      viewBox="0 0 420 128"
                      preserveAspectRatio="none"
                      style={{ width: '100%', height: '150px' }}
                    >
                      {' '}
                      {(m.anEntryDayRows ?? []).map((r, i88) => (
                        <Fragment key={i88}>
                          <line x1="10" y1={dc.a(r?.y)} x2="410" y2={dc.a(r?.y)} stroke="var(--l6)"></line>
                        </Fragment>
                      ))}{' '}
                      {(m.anEntryDayScatter ?? []).map((p, i89) => (
                        <Fragment key={i89}>
                          <circle
                            cx={dc.a(p?.cx)}
                            cy={dc.a(p?.cy)}
                            r={dc.a(p?.r)}
                            fill={dc.a(p?.fill)}
                            fillOpacity="0.72"
                          >
                            <title>{dc.t(p?.title)}</title>
                          </circle>
                        </Fragment>
                      ))}{' '}
                    </svg>{' '}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2px' }}>
                      <span style={{ fontSize: '9px', color: 'var(--faint)' }}>00:00</span>
                      <span style={{ fontSize: '9px', color: 'var(--faint)' }}>12:00</span>
                      <span style={{ fontSize: '9px', color: 'var(--faint)' }}>24:00</span>
                    </div>{' '}
                  </div>{' '}
                </div>{' '}
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Trade Duration vs Entry Time</div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  {"How long trades run depending on when they're opened · up to "}
                  {dc.t(m.anDurationPeak)}
                </div>{' '}
                <svg
                  viewBox="0 0 420 128"
                  preserveAspectRatio="none"
                  style={{ width: '100%', height: '160px', marginTop: '14px' }}
                >
                  {' '}
                  <line x1="10" y1="10" x2="410" y2="10" stroke="var(--l6)"></line>{' '}
                  <line x1="10" y1="69" x2="410" y2="69" stroke="var(--l6)"></line>{' '}
                  <line x1="10" y1="128" x2="410" y2="128" stroke="var(--l8)"></line>{' '}
                  {(m.anDurationScatter ?? []).map((p, i90) => (
                    <Fragment key={i90}>
                      <circle cx={dc.a(p?.cx)} cy={dc.a(p?.cy)} r="4" fill={dc.a(p?.fill)} fillOpacity="0.72">
                        <title>{dc.t(p?.title)}</title>
                      </circle>
                    </Fragment>
                  ))}{' '}
                </svg>{' '}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2px' }}>
                  <span style={{ fontSize: '9px', color: 'var(--faint)' }}>00:00</span>
                  <span style={{ fontSize: '9px', color: 'var(--faint)' }}>12:00</span>
                  <span style={{ fontSize: '9px', color: 'var(--faint)' }}>24:00</span>
                </div>{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
              }}
            >
              {' '}
              <div style={{ fontSize: '12.5px', fontWeight: '500' }}>
                Time-of-Day Profitability Heat Map
              </div>{' '}
              <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                4-hour windows × weekday · hover a cell for trades, win rate and P&L
              </div>{' '}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '60px repeat(5,1fr)',
                  gap: '6px',
                  marginTop: '14px',
                }}
              >
                {' '}
                <span></span>{' '}
                {(m.anHourHeatDows ?? []).map((d, i91) => (
                  <Fragment key={i91}>
                    <span
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.09em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                        textAlign: 'center',
                      }}
                    >
                      {dc.t(d)}
                    </span>
                  </Fragment>
                ))}{' '}
              </div>{' '}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px' }}>
                {' '}
                {(m.anHourHeat ?? []).map((row, i92) => (
                  <Fragment key={i92}>
                    {' '}
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '60px repeat(5,1fr)',
                        gap: '6px',
                        alignItems: 'stretch',
                      }}
                    >
                      {' '}
                      <span
                        style={{
                          fontSize: '10px',
                          color: 'var(--text2)',
                          display: 'flex',
                          alignItems: 'center',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(row?.label)}
                      </span>{' '}
                      {(row?.cells ?? []).map((c, i93) => (
                        <Fragment key={i93}>
                          {' '}
                          <div
                            title={dc.a(c?.title)}
                            style={dc.css(
                              `border-radius:8px;background:${dc.s(c?.bg)};padding:8px 6px;min-height:44px;display:flex;align-items:center;justify-content:center`,
                            )}
                          >
                            <span
                              style={dc.css(
                                `font-size:10px;font-weight:600;color:${dc.s(c?.pnlFg)};font-variant-numeric:tabular-nums`,
                              )}
                            >
                              {dc.t(c?.pnl)}
                            </span>
                          </div>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.anIsStrats ? (
        <>
          {' '}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,320px),1fr))',
              gap: '14px',
              alignItems: 'start',
            }}
          >
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
              }}
            >
              <div style={{ fontSize: '12.5px', fontWeight: '500' }}>By strategy</div>{' '}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '11px', marginTop: '12px' }}>
                {' '}
                {(m.anStrats ?? []).map((g, i94) => (
                  <Fragment key={i94}>
                    {' '}
                    <div>
                      {' '}
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span
                          style={{
                            fontSize: '11.5px',
                            color: 'var(--text2)',
                            flex: '1',
                            minWidth: '0',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {dc.t(g?.label)}
                        </span>
                        <span
                          style={{
                            fontSize: '10px',
                            color: 'var(--muted2)',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(g?.count)}
                          {' · '}
                          {dc.t(g?.wr)}
                        </span>
                        <span
                          style={dc.css(
                            `font-size:11.5px;font-weight:600;color:${dc.s(g?.pnlFg)};font-variant-numeric:tabular-nums`,
                          )}
                        >
                          {dc.t(g?.pnl)}
                        </span>
                      </div>{' '}
                      <div
                        style={{
                          height: '4px',
                          borderRadius: '99px',
                          background: 'var(--l6)',
                          marginTop: '6px',
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={dc.css(
                            `width:${dc.s(g?.w)};height:100%;border-radius:99px;background:${dc.s(g?.bar)}`,
                          )}
                        ></div>
                      </div>{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                overflow: 'hidden',
              }}
            >
              {' '}
              <div style={{ padding: '12px 16px', fontSize: '12.5px', fontWeight: '500' }}>
                Expectancy per strategy
              </div>{' '}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns:
                    'minmax(90px,1.6fr) minmax(50px,0.8fr) minmax(44px,0.6fr) minmax(50px,0.8fr) minmax(40px,0.6fr) minmax(60px,0.9fr)',
                  gap: '10px',
                  alignItems: 'center',
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                  padding: '9px 16px',
                  borderTop: '1px solid var(--l6)',
                  borderBottom: '1px solid var(--l8)',
                }}
              >
                <span>Strategy</span>
                <span style={{ textAlign: 'right' }}>Trades</span>
                <span style={{ textAlign: 'right' }}>Win %</span>
                <span style={{ textAlign: 'right' }}>Expectancy</span>
                <span style={{ textAlign: 'right' }}>PF</span>
                <span style={{ textAlign: 'right' }}>Net</span>
              </div>{' '}
              {(m.anStratExp ?? []).map((s, i95) => (
                <Fragment key={i95}>
                  {' '}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns:
                        'minmax(90px,1.6fr) minmax(50px,0.8fr) minmax(44px,0.6fr) minmax(50px,0.8fr) minmax(40px,0.6fr) minmax(60px,0.9fr)',
                      gap: '10px',
                      alignItems: 'center',
                      fontSize: '11.5px',
                      padding: '10px 16px',
                      borderBottom: '1px solid var(--l8)',
                    }}
                  >
                    {' '}
                    <span
                      style={{
                        color: 'var(--text2)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {dc.t(s?.label)}
                    </span>{' '}
                    <span
                      style={{
                        textAlign: 'right',
                        color: 'var(--muted)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(s?.count)}
                    </span>{' '}
                    <span
                      style={{
                        textAlign: 'right',
                        color: 'var(--muted)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(s?.wr)}
                    </span>{' '}
                    <span
                      style={dc.css(
                        `text-align:right;font-weight:600;color:${dc.s(s?.expFg)};font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(s?.exp)}
                    </span>{' '}
                    <span
                      style={{
                        textAlign: 'right',
                        color: 'var(--text2)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(s?.pf)}
                    </span>{' '}
                    <span
                      style={dc.css(
                        `text-align:right;font-weight:600;color:${dc.s(s?.pnlFg)};font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(s?.pnl)}
                    </span>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.anIsTech ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            {' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,320px),1fr))',
                gap: '14px',
                alignItems: 'start',
              }}
            >
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Direction</div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  Long against short over this range
                </div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '12px' }}>
                  {' '}
                  {(m.anDirection ?? []).map((d, i96) => (
                    <Fragment key={i96}>
                      {' '}
                      <div>
                        {' '}
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                          <span style={{ fontSize: '11.5px', color: 'var(--text2)', flex: '1' }}>
                            {dc.t(d?.label)}
                          </span>
                          <span
                            style={{
                              fontSize: '10px',
                              color: 'var(--muted)',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(d?.count)}
                            {' · '}
                            {dc.t(d?.wr)}
                          </span>
                          <span
                            style={dc.css(
                              `font-size:11.5px;font-weight:600;color:${dc.s(d?.pnlFg)};font-variant-numeric:tabular-nums`,
                            )}
                          >
                            {dc.t(d?.pnlStr)}
                          </span>
                        </div>{' '}
                        <div
                          style={{
                            height: '5px',
                            borderRadius: '99px',
                            background: 'var(--l6)',
                            marginTop: '6px',
                            overflow: 'hidden',
                          }}
                        >
                          <div
                            style={dc.css(
                              `width:${dc.s(d?.w2)};height:100%;border-radius:99px;background:${dc.s(d?.bar)}`,
                            )}
                          ></div>
                        </div>{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Instrument class</div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  Where the exposure actually sits
                </div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '11px', marginTop: '12px' }}>
                  {' '}
                  {(m.anClasses ?? []).map((g, i97) => (
                    <Fragment key={i97}>
                      {' '}
                      <div>
                        {' '}
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                          <span
                            style={{
                              fontSize: '11.5px',
                              color: 'var(--text2)',
                              flex: '1',
                              minWidth: '0',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {dc.t(g?.label)}
                          </span>
                          <span
                            style={{
                              fontSize: '10px',
                              color: 'var(--muted)',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(g?.count)}
                            {' · '}
                            {dc.t(g?.wr)}
                          </span>
                          <span
                            style={dc.css(
                              `font-size:11.5px;font-weight:600;color:${dc.s(g?.pnlFg)};font-variant-numeric:tabular-nums`,
                            )}
                          >
                            {dc.t(g?.pnl)}
                          </span>
                        </div>{' '}
                        <div
                          style={{
                            height: '4px',
                            borderRadius: '99px',
                            background: 'var(--l6)',
                            marginTop: '6px',
                            overflow: 'hidden',
                          }}
                        >
                          <div
                            style={dc.css(
                              `width:${dc.s(g?.w)};height:100%;border-radius:99px;background:${dc.s(g?.bar)}`,
                            )}
                          ></div>
                        </div>{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,320px),1fr))',
                gap: '14px',
                alignItems: 'start',
              }}
            >
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Hold time</div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  P&L by how long the position was open
                </div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '11px', marginTop: '12px' }}>
                  {' '}
                  {(m.anHold ?? []).map((b, i98) => (
                    <Fragment key={i98}>
                      {' '}
                      <div>
                        {' '}
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                          <span style={{ fontSize: '11.5px', color: 'var(--text2)', flex: '1' }}>
                            {dc.t(b?.label)}
                          </span>
                          <span
                            style={{
                              fontSize: '10px',
                              color: 'var(--muted)',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(b?.count)}
                            {' · '}
                            {dc.t(b?.wr)}
                          </span>
                          <span
                            style={dc.css(
                              `font-size:11.5px;font-weight:600;color:${dc.s(b?.pnlFg)};font-variant-numeric:tabular-nums`,
                            )}
                          >
                            {dc.t(b?.pnl)}
                          </span>
                        </div>{' '}
                        <div
                          style={{
                            height: '4px',
                            borderRadius: '99px',
                            background: 'var(--l6)',
                            marginTop: '6px',
                            overflow: 'hidden',
                          }}
                        >
                          <div
                            style={dc.css(
                              `width:${dc.s(b?.w)};height:100%;border-radius:99px;background:${dc.s(b?.bar)}`,
                            )}
                          ></div>
                        </div>{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>R-multiple distribution</div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  {dc.t(m.anRUnit)}
                </div>{' '}
                <div
                  style={{
                    height: '130px',
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '8px',
                    marginTop: '14px',
                  }}
                >
                  {' '}
                  {(m.anRDist ?? []).map((b, i99) => (
                    <Fragment key={i99}>
                      {' '}
                      <div
                        style={{
                          flex: '1',
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-end',
                          gap: '4px',
                        }}
                      >
                        <span
                          style={{
                            textAlign: 'center',
                            fontSize: '9.5px',
                            color: 'var(--muted)',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(b?.count)}
                        </span>
                        <div
                          style={dc.css(
                            `width:100%;height:${dc.s(b?.h)};min-height:2px;border-radius:3px 3px 0 0;background:${dc.s(b?.bar)}`,
                          )}
                        ></div>
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
                <div style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>
                  {' '}
                  {(m.anRDist ?? []).map((b, i100) => (
                    <Fragment key={i100}>
                      <span
                        style={{ flex: '1', textAlign: 'center', fontSize: '9px', color: 'var(--faint)' }}
                      >
                        {dc.t(b?.label)}
                      </span>
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
              }}
            >
              {' '}
              <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Position size bands</div>{' '}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit,minmax(min(50%,180px),1fr))',
                  gap: '10px',
                  marginTop: '12px',
                }}
              >
                {' '}
                {(m.anLotBands ?? []).map((b, i101) => (
                  <Fragment key={i101}>
                    {' '}
                    <div
                      style={{
                        border: '1px solid var(--l8)',
                        borderRadius: '11px',
                        background: 'var(--l3)',
                        padding: '11px 13px',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        {dc.t(b?.label)}
                        {' lots'}
                      </div>
                      <div
                        style={dc.css(
                          `font-size:14px;font-weight:600;color:${dc.s(b?.pnlFg)};margin-top:4px;font-variant-numeric:tabular-nums`,
                        )}
                      >
                        {dc.t(b?.pnl)}
                      </div>
                      <div
                        style={{
                          fontSize: '10px',
                          color: 'var(--muted)',
                          marginTop: '2px',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(b?.count)}
                        {' · '}
                        {dc.t(b?.wr)}
                        {' won'}
                      </div>
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.anIsBehaviour ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            {' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(50%,190px),1fr))',
                gap: '12px',
              }}
            >
              {' '}
              {(m.anBehaviour ?? []).map((b, i102) => (
                <Fragment key={i102}>
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '13px 15px',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      {dc.t(b?.k)}
                    </div>
                    <div
                      style={dc.css(
                        `font-size:17px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(b?.c)};margin-top:4px;font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(b?.v)}
                    </div>
                    <div
                      style={{
                        fontSize: '10px',
                        color: 'var(--muted)',
                        marginTop: '3px',
                        lineHeight: '1.45',
                      }}
                    >
                      {dc.t(b?.sub)}
                    </div>
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
              }}
            >
              {' '}
              <div style={{ fontSize: '12.5px', fontWeight: '500' }}>On plan against off plan</div>{' '}
              <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                Every entry split by whether its strategy was armed in Session Setup
              </div>{' '}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '11px', marginTop: '12px' }}>
                {' '}
                {(m.anBehaviourStrats ?? []).map((g, i103) => (
                  <Fragment key={i103}>
                    {' '}
                    <div>
                      {' '}
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span
                          style={{
                            fontSize: '11.5px',
                            color: 'var(--text2)',
                            flex: '1',
                            minWidth: '0',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {dc.t(g?.label)}
                        </span>
                        <span
                          style={{
                            fontSize: '10px',
                            color: 'var(--muted)',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(g?.count)}
                          {' · '}
                          {dc.t(g?.wr)}
                        </span>
                        <span
                          style={dc.css(
                            `font-size:11.5px;font-weight:600;color:${dc.s(g?.pnlFg)};font-variant-numeric:tabular-nums`,
                          )}
                        >
                          {dc.t(g?.pnl)}
                        </span>
                      </div>{' '}
                      <div
                        style={{
                          height: '4px',
                          borderRadius: '99px',
                          background: 'var(--l6)',
                          marginTop: '6px',
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={dc.css(
                            `width:${dc.s(g?.w)};height:100%;border-radius:99px;background:${dc.s(g?.bar)}`,
                          )}
                        ></div>
                      </div>{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.anIsTrades ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              overflow: 'hidden',
            }}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '9px',
                padding: '12px 16px',
                flexWrap: 'wrap',
              }}
            >
              {' '}
              <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Trade Log</span>{' '}
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                {' '}
                {(m.anLogAcctChips ?? []).map((a, i104) => (
                  <Fragment key={i104}>
                    {' '}
                    <button
                      className="scp-d9c1ec4"
                      onClick={a?.go}
                      aria-label={`Toggle ${dc.s(a?.label)}`}
                      aria-pressed={dc.b(a?.on)}
                      style={dc.css(
                        `font-size:10.5px;padding:4px 11px;border-radius:99px;border:1px solid ${dc.s(a?.bd)};background:${dc.s(a?.bg)};color:${dc.s(a?.fg)};cursor:pointer`,
                      )}
                    >
                      {dc.t(a?.label)}
                    </button>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
              <div style={{ flex: '1' }}></div>{' '}
              <span
                style={{ fontSize: '10.5px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}
              >
                {dc.t(m.anLogCount)}
              </span>{' '}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns:
                  'minmax(52px,0.7fr) minmax(64px,0.9fr) minmax(48px,0.6fr) minmax(64px,0.8fr) minmax(64px,0.8fr) minmax(70px,0.9fr) minmax(96px,1.1fr)',
                gap: '10px',
                alignItems: 'center',
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                padding: '9px 16px',
                borderTop: '1px solid var(--l6)',
                borderBottom: '1px solid var(--l8)',
              }}
            >
              <span>Date</span>
              <span>Symbol</span>
              <span>Side</span>
              <span style={{ textAlign: 'right' }}>Entry</span>
              <span style={{ textAlign: 'right' }}>Exit</span>
              <span style={{ textAlign: 'right' }}>Net</span>
              <span>Strategy</span>
            </div>{' '}
            {(m.anLog ?? []).map((t, i105) => (
              <Fragment key={i105}>
                {' '}
                <div
                  style={dc.css(
                    `padding:9px 16px;border-bottom:1px solid var(--l8);background:${dc.s(t?.rowBg)}`,
                  )}
                >
                  {' '}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns:
                        'minmax(52px,0.7fr) minmax(64px,0.9fr) minmax(48px,0.6fr) minmax(64px,0.8fr) minmax(64px,0.8fr) minmax(70px,0.9fr) minmax(96px,1.1fr)',
                      gap: '10px',
                      alignItems: 'center',
                      fontSize: '11.5px',
                    }}
                  >
                    {' '}
                    <span style={{ color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}>
                      {dc.t(t?.date)}
                    </span>{' '}
                    <span style={{ fontWeight: '500' }}>{dc.t(t?.sym)}</span>{' '}
                    <span>
                      <span
                        style={dc.css(
                          `font-size:9px;font-weight:600;letter-spacing:0.06em;padding:2px 7px;border-radius:99px;background:${dc.s(t?.sideBg)};color:${dc.s(t?.sideFg)}`,
                        )}
                      >
                        {dc.t(t?.side)}
                      </span>
                    </span>{' '}
                    <span
                      style={{
                        textAlign: 'right',
                        color: 'var(--muted)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(t?.entry)}
                    </span>{' '}
                    <span
                      style={{
                        textAlign: 'right',
                        color: 'var(--muted)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(t?.exit)}
                    </span>{' '}
                    <span
                      style={dc.css(
                        `text-align:right;font-weight:600;color:${dc.s(t?.pnlFg)};font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(t?.pnl)}
                    </span>{' '}
                    <span
                      style={{
                        color: 'var(--muted2)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {dc.t(t?.strat)}
                    </span>{' '}
                  </div>{' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '5px' }}>
                    <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>{dc.t(t?.acct)}</span>
                    <span
                      style={{ fontSize: '10px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}
                    >
                      {dc.t(t?.lots)}L
                    </span>
                  </div>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </>
      ) : null}
    </div>
  );
}
